@if (icon() || description()) {
  <div class="heading">
    @if (icon(); as icon) {
      <onyx-icon
        class="white"
        [name]="icon.name"
        [size]="icon.size"
        [frame]="icon.frame"
      ></onyx-icon>
    }

    <p class="f-body-s f-medium">{{ heading() | translate }}</p>
  </div>
}

@if (description(); as description) {
  <p class="f-body-s f-muted">{{ description | translate }}</p>
}
